<template>
  <div class="brand-detail" v-if="Object.keys(brandDetail).length > 0">
    <innerBanner :banner="is_mob ? innerBannerMo : innerBanner" />
    <div class="wp2 bd-wrap">
      <div class="bd-row-list">
        <div class="bd-row" v-for="(item, index) in brandDetail.attributes.Stories" :key="item.id">
          <div class="pic" v-if="index % 2 === 1 && item.story_pic.data">
            <img :alt="item.story_title" :src="item.story_pic.data.attributes.url" />
          </div>
          <div class="txt">
            <h1>{{ item.story_title }}</h1>
            <p>{{ item.story_description }}</p>
          </div>
          <div class="pic" v-if="index % 2 === 0 && item.story_pic.data">
            <img :alt="item.story_title" :src="item.story_pic.data.attributes.url" />
          </div>
        </div>
      </div>
      <div class="goods">
        <div class="title">旗下产品</div>
        <div class="goods-list2" v-loading="isLoading">
          <template v-for="(item, index) in lang === 'zh' ? goodsList : goodsListEn">
            <goodsItem
              v-if="(is_mob && (index < 6 || showAll)) || !is_mob"
              :key="index"
              :item="item"
            />
          </template>
        </div>
        <div class="page">
          <el-pagination
            v-if="showAll || !is_mob"
            layout="prev, pager, next"
            :total="total"
            @current-change="pageChange"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>

      <div class="big-btn hollow" @click="showAll = true" v-if="!showAll && is_mob">
        {{ $t('brandDetail.viewMore') }}
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import innerBanner from '@/components/innerBanner'
import goodsItem from '@/components/goodsItem'

export default {
  name: 'brandDetail',
  props: ['brandName'],
  components: {
    innerBanner,
    goodsItem
  },
  data() {
    return {
      lang: this.$i18n.locale,
      brandDetail: {},
      innerBanner: {},
      innerBannerMo: {},
      is_mob: false,
      showAll: false,
      isLoading: false,
      total: 0,
      currPage: 1,
      pageSize: 20,
      goodsList: [],
      goodsListEn: []
    }
  },
  created() {
    this.getBrand()
    this.getBrandProducts()
  },
  activated() {
    this.changeBanner()
    this.initListener()
  },
  deactivated() {
    this.destroyListener()
  },
  methods: {
    async getBrand() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          filters: {
            slug: {
              $eq: this.brandName
            }
          },
          pagination: {
            start: 0,
            limit: 1
          },
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: { data: res }
      } = await this.$http.get(`${this.$strapiUrl}/brands?${queryInfo}`)
      this.brandDetail = { ...res[0] }
      if (!this.brandDetail.attributes) return false
      this.innerBanner = {
        img: this.brandDetail.attributes.page_banner.data.attributes.url,
        title: this.brandDetail.attributes.page_title,
        desc: this.brandDetail.attributes.page_subtitle
      }
      this.innerBannerMo = {
        img: this.brandDetail.attributes.page_bannermo.data.attributes.url,
        title: this.brandDetail.attributes.page_title,
        desc: this.brandDetail.attributes.page_subtitle
      }
    },
    async getBrandProducts() {
      this.isLoading = true
      const query = {
        brandName: this.brandName,
        currPage: this.currPage,
        pageSize: this.pageSize
      }
      const { data: res } = await this.$http.get(`${this.$baseUrl}/get-brandprod`, {
        params: query
      })
      if (res.meta.status !== 200) return this.$message.error('获取商品列表失败！')
      this.goodsList = res.data.prodArr.map((item) => {
        return {
          id: item._id,
          img: item.avatarPublicUrl,
          brand: item.brand_cn,
          name: item.item_cn,
          sku: item.sku,
          upc: item.upc
        }
      })
      this.goodsListEn = res.data.prodArr.map((item) => {
        return {
          id: item._id,
          img: item.avatarPublicUrl,
          brand: item.brand_en,
          name: item.item_en,
          sku: item.sku,
          upc: item.upc
        }
      })
      this.total = res.data.total
      this.isLoading = false
    },
    pageChange(page) {
      this.currPage = page
      this.getBrandProducts()
    },
    initListener() {
      this.$_resizeHandler = this.myDebounce(() => {
        this.changeBanner()
      })
      window.addEventListener('resize', this.$_resizeHandler)
    },
    destroyListener() {
      window.removeEventListener('resize', this.$_resizeHandler)
      this.$_resizeHandler = null
    },
    changeBanner() {
      this.is_mob = window.innerWidth <= 767
    }
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.lang = newValue
      this.getBrand()
      this.getBrandProducts()
    }
  }
}
</script>

<style scoped lang="scss">
//brand-detail
.brand-detail {
  .bd-wrap {
    padding: 66px 0;
  }
  .bd-row + .bd-row {
    margin-top: 16px;
  }
  .bd-row-list {
    padding-bottom: 80px;
  }
  .bd-row {
    display: flex;
    .txt,
    .pic {
      flex: 1 0 50%;
    }
    .txt {
      padding: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: $white2;
      h1 {
        @extend .h1-36px;
        margin-bottom: 24px;
      }
      p {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .txt.tac {
      text-align: center;
    }
    .pic img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .goods {
    .title {
      font-weight: 600;
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 32px;
    }
    .goods-list2 {
      margin: 0 -10px;
      .goods-item {
        flex: 0 0 calc(20% - 20px);
        margin: 0 10px 48px;
      }
    }
    .page {
      text-align: center;
    }
  }
}

@media only screen and (max-width: 1199px) {
  .brand-detail .bd-wrap {
    padding: 66px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .brand-detail .bd-row {
    display: block;
  }
  .brand-detail .bd-row .txt {
    padding: 20px;
  }
  .brand-detail .bd-row .txt h1 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .brand-detail .bd-row .txt p {
    font-size: 14px;
    line-height: 150%;
  }
  .brand-detail .bd-row-list {
    padding-bottom: 60px;
  }
  .brand-detail .goods .title {
    margin-bottom: 20px;
  }
  .brand-detail .goods .goods-list2 {
    margin: 0 -5px;
    .goods-item {
      flex: 0 0 calc(50% - 10px);
      margin: 0 5px 10px;
    }
  }
  .big-btn {
    margin: 20px auto 0;
  }
}
</style>
